import { inject } from '@angular/core';
import { CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { catchError, map, of } from 'rxjs';

import { AuthService, SessionService } from '../services';
import { HREF } from '../constants';

const PLAYER_ID_PARAM = 'playerId';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const sessionService = inject(SessionService);

  const notFound = (): UrlTree => router.createUrlTree(['/', HREF.NOT_FOUND]);
  const signInFailed = (): UrlTree => router.createUrlTree(['/', HREF.SIGN_IN_FAILED]);

  // Casino link: exchange the player id for an access token on every visit,
  // so the same link can be reused while the event is open.
  const playerId = route.queryParams[PLAYER_ID_PARAM];
  if (playerId) {
    return authService.authenticate(playerId).pipe(
      map(() => {
        sessionService.clearSessionExpiration();
        return stripPlayerIdFromStateUrl(state, router);
      }),
      // Any auth failure (400, 401, 500, network) shows the same "sign in again" page.
      catchError(() => {
        authService.logout();
        return of(signInFailed());
      }),
    );
  }

  if (authService.isTokenValid(authService.token)) {
    return true;
  }

  authService.logout();
  return notFound();
};

function stripPlayerIdFromStateUrl(state: RouterStateSnapshot, router: Router): UrlTree {
  const tree = router.parseUrl(state.url);

  const qp = { ...tree.queryParams };
  delete qp[PLAYER_ID_PARAM];
  tree.queryParams = qp;

  return tree;
}
